/**
 * Create Advanced Filter Price Range Slider web component.
 * Use this component to render Advanced Advanced Filter Price Range Slider element
 */
class SHTAdvancedFilterPriceRangeSlider extends HTMLElement {
  constructor() {
    super();
    this.elms = {
      input_elms: this.querySelectorAll(
        `[data-type="price-range-slider-input"]`
      ),
      lte_slider_elm: this.querySelector(`[data-type-price="slider-lte"]`),
      gte_slider_elm: this.querySelector(`[data-type-price="slider-gte"]`),
      min_gap: 0,
      slider_track: this.querySelector(`[data-type-track="slider-track"]`),
    };
    this.reverse = false;
    this.color = this.dataset.advancedFilterPriceRangeSliderColor;
    this.color_shadow = this.dataset.advancedFilterPriceRangeSliderColorShadow;
    console.log(this.color_shadow);
    this.bindEventHandlers();
    this.fillBgColor(this.reverse);
  }
  /**
   * bind event handler to web component elements
   */
  bindEventHandlers() {
    this.elms.input_elms.forEach((element) =>
      element.addEventListener(
        "input",
        this.onRangeSliderChangeHandle.bind(this)
      )
    );
  }
  /**
   * Handle the range change event
   * @param Event event
   */
  onRangeSliderChangeHandle(event) {
    this.adjustToValidValues(event);
  }
  /**
   * Set min/max attribute
   */
  adjustToValidValues(input) {
    let slide1 = this.elms.gte_slider_elm.value;
    let slide2 = this.elms.lte_slider_elm.value;

    if (slide1 > slide2) {
      let tmp = slide2;
      slide2 = slide1;
      slide1 = tmp;
      this.reverse = true;
    }

    this.fillBgColor();
    let advancedFilterPriceRange = this.closest(
      "sht-advanced-filter-price-range"
    );
    advancedFilterPriceRange.setValues(slide1, slide2);
  }
  /**
   * Fill background color for slider range
   */
  fillBgColor() {
    let percent1 =
      (this.elms.gte_slider_elm.value / this.elms.gte_slider_elm.max) * 100;
    let percent2 =
      (this.elms.lte_slider_elm.value / this.elms.lte_slider_elm.max) * 100;

    if (this.reverse) {
      percent1 =
        (this.elms.lte_slider_elm.value / this.elms.lte_slider_elm.max) * 100;
      percent2 =
        (this.elms.gte_slider_elm.value / this.elms.gte_slider_elm.max) * 100;
      this.reverse = false;
    }

    this.elms.slider_track.style.background = `linear-gradient(to right, ${this.color_shadow} ${percent1}%, ${this.color} ${percent1}%, ${this.color} ${percent2}%, ${this.color_shadow} ${percent2}%)`;
  }
}

// Register to the Browser from `customElements` API
customElements.define(
  "sht-advanced-filter-price-range-slider",
  SHTAdvancedFilterPriceRangeSlider
);
